import { type AggregateMap } from '../search/types';

import { type Brand, type BrandResponse } from './aliases';
import { UNKNOWN_BRAND_ID } from './constants';

function filterUnknownBrand(brand: Brand) {
  return brand.id !== UNKNOWN_BRAND_ID;
}

export function getBrandsBySlugs(brands: BrandResponse, slugs: string[]) {
  return Object.values(brands).filter((brand) => slugs.includes(brand.slug));
}

export function buildPopularBrands({
  brands,
  brandAggregates,
  maxCount,
  allowedBrandSlugs = [],
}: {
  brands: BrandResponse;
  brandAggregates: AggregateMap;
  maxCount?: number;
  allowedBrandSlugs?: string[];
}) {
  if (allowedBrandSlugs?.length > 0) {
    return getBrandsBySlugs(brands, allowedBrandSlugs)
      .filter(Boolean)
      .filter(filterUnknownBrand)
      .sort((a, b) => a.name.localeCompare(b.name))
      .slice(0, maxCount);
  }

  const sortedAggregates = Object.entries(brandAggregates)
    .map(([key, { count }]) => ({ id: key, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, maxCount);

  return sortedAggregates
    .map(({ id }) => brands[id] ?? null)
    .filter(Boolean)
    .filter(filterUnknownBrand);
}

export function getBrandSlug(brands: BrandResponse = {}, id?: string[]) {
  if (!(id && id.length)) {
    return undefined;
  }

  return brands[id[0]]?.slug;
}

export function getBrandBySlug(brands: BrandResponse = {}, slug?: string) {
  return Object.values(brands).find((brand) => brand.slug === slug);
}
